import { InputGroup, Input, InputLeftElement } from '@chakra-ui/react';
import { FieldAttributes } from 'formik';
import { FormSchema } from 'lib/types';
import { FC, forwardRef, Ref } from 'react';

type Props = {
  schema: FormSchema<any>;
  field: FieldAttributes<any>;
  size?: 'sm' | 'md' | 'lg';
  icon: JSX.Element;
}

export const InputWithIcon: FC<Props> = forwardRef((
  { schema, field, icon, size = 'md' }, ref?: Ref<HTMLInputElement>
) => (
    <InputGroup size={size} ref={ref || null}>
      <InputLeftElement height="100%" width="30px" ml="15px">
        {icon}
      </InputLeftElement>
      <Input size={size} {...schema} {...field} />
    </InputGroup>
  )
);

InputWithIcon.displayName = "InputWithIcon";
